var map = {
	"./audio-muted.svg": 2871,
	"./audio.svg": 465,
	"./copy.svg": 8466,
	"./external-link.svg": 3877,
	"./github.svg": 7092,
	"./language.svg": 6979,
	"./video-muted.svg": 1600,
	"./video.svg": 998
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8202;